import React from 'react';
import moment from 'moment';

// This class is used for DatePicker fields
// It allows the user to select a date using the DatePicker, while preventing them from manually deleting the text in the text box
class NoWriteDateInput extends React.Component {
    constructor(props) {
        super(props);
        this.checkIfDate = this.checkIfDate.bind(this);
    }
  
    checkIfDate(date) {
        if (!moment.isMoment(date)) return;
        this.props.onChange(date);
    }
  
    render() {
        const props = {...this.props};
        delete props.onChange;
        return (
            <input type="text" onChange={this.checkIfDate} {...props} />
        );
    }
}

export default NoWriteDateInput;


// WEBPACK FOOTER //
// ./src/components/NoWriteDateInput.js